import React from 'react';

// components
import { Box } from '@lyearn/ui';
import RichTextViewer from '@/components/RichTextViewer';
import { useHeroContext } from '@/modules/corporate/components/DetailPageComponents/DetailHero/context';

import { HeroComposition } from '../../types';

const Introduction: HeroComposition['Introduction'] = (props) => {
  const { numberOfLines, className } = props;
  const {
    content: { objective },
  } = useHeroContext();

  if (!objective) return null;
  return (
    <Box className={className}>
      <RichTextViewer
        truncate
        className="flex-shrink text-text-paragraph"
        html={objective}
        numberOfLines={numberOfLines || 2}
        variant="body-long-01"
      />
    </Box>
  );
};

export default Introduction;
